/* One layout pass for stock ordering and promotions across every loaded page. */
(function () {
  const container = document.getElementById('ProductGridContainer');
  if (!container || container.dataset.tmbLayoutBound) return;
  container.dataset.tmbLayoutBound = 'true';
  const mobile = window.matchMedia('(max-width: 767px)');
  let scheduled = false;
  let activeGrid;
  let banners = [];

  function layout() {
    const grid = container.querySelector('#product-grid');
    if (!grid) return;
    const template = container.querySelector('template[data-tmb-collection-banners]');
    if (grid !== activeGrid) {
      activeGrid = grid;
      banners = template ? Array.from(template.content.children).map(node => node.cloneNode(true)) : [];
      banners.forEach(banner => {
        const link = banner.querySelector('[data-tmb-banner-link]');
        if (!link || !['popular', 'budget'].includes(link.dataset.tmbBannerLink)) return;
        const url = new URL(link.href, window.location.href);
        const current = new URL(window.location.href);
        current.searchParams.forEach((value, key) => {
          if (key.startsWith('filter.')) url.searchParams.append(key, value);
        });
        link.href = url.href;
      });
    }
    const children = Array.from(grid.children);
    const available = [], soldOut = [], overlays = [];
    children.forEach(node => {
      if (node.classList.contains('loading-overlay')) overlays.push(node);
      else if (template && node.classList.contains('promotion-column')) return;
      else if (node.classList.contains('tmb-soldout')) soldOut.push(node);
      else available.push(node);
    });

    const desired = [];
    const columns = mobile.matches ? 2 : Math.max(2, Number(grid.dataset.columns) || 4);
    const first = columns * 2;
    const spacing = columns * 4;
    available.forEach((node, index) => {
      desired.push(node);
      const count = index + 1;
      const bannerIndex = (count - first) / spacing;
      // Leave a full row of products after a banner; never end a list with ads.
      if (template && Number.isInteger(bannerIndex) && bannerIndex >= 0 &&
          bannerIndex < banners.length && available.length >= count + columns) {
        desired.push(banners[bannerIndex]);
      }
    });
    desired.push(...soldOut, ...overlays);
    if (desired.length === children.length && desired.every((node, index) => node === children[index])) return;

    const retained = new Set(desired);
    children.forEach(node => { if (!retained.has(node)) node.remove(); });
    // Move only misplaced nodes. Existing product elements and their listeners survive.
    desired.forEach((node, index) => {
      if (grid.children[index] !== node) grid.insertBefore(node, grid.children[index] || null);
    });
  }

  const observer = new MutationObserver(schedule);
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      observer.disconnect();
      layout();
      observer.observe(container, { childList: true, subtree: true });
    });
  }
  layout();
  observer.observe(container, { childList: true, subtree: true });
  mobile.addEventListener('change', schedule);
})();
